import { render, staticRenderFns } from "./Szuperkepessegek.vue?vue&type=template&id=4efbe833&"
import script from "./Szuperkepessegek.vue?vue&type=script&lang=js&"
export * from "./Szuperkepessegek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports